var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBusinessA({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1829",
    "data-name": "\\uC0AC\\uAC01\\uD615 1829",
    width: 61.535,
    height: 81.648,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4013",
    "data-name": "\\uADF8\\uB8F9 4013",
    transform: "translate(1112 8483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3998",
    "data-name": "\\uADF8\\uB8F9 3998",
    transform: "translate(-1092.405 -8473.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3997",
    "data-name": "\\uADF8\\uB8F9 3997",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_125",
    "data-name": "\\uD328\\uC2A4 125",
    d: "M44.227,33.072v5.164a11.9,11.9,0,0,1-23.808,0V33.072H17.683v5.164A14.657,14.657,0,0,0,30.954,52.807V75.345H24.186v2.736H40.459V75.345H33.69V52.807A14.657,14.657,0,0,0,46.963,38.236V33.072Z",
    transform: "translate(-1.556 -2.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_126",
    "data-name": "\\uD328\\uC2A4 126",
    d: "M32.817,12.611a9.515,9.515,0,0,0-9.5,9.505V36.585a9.5,9.5,0,1,0,19.009,0V22.116a9.516,9.516,0,0,0-9.505-9.505m0,30.743a6.776,6.776,0,0,1-6.6-5.3h4.223V35.316H26.049V32.688h4.388V29.951H26.049V27.323h4.388V24.587H26.049V22.116a6.767,6.767,0,0,1,3.02-5.632v3.25H31.8v-4.3a6.859,6.859,0,0,1,1.012-.084c.206,0,.409.013.61.031v4.357h2.736V16.24a6.768,6.768,0,0,1,3.423,5.876v2.471H34.8v2.736h4.791v2.628H34.8v2.736h4.791v2.628H34.8v2.736h4.626a6.776,6.776,0,0,1-6.6,5.3",
    transform: "translate(-2.051 -1.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_127",
    "data-name": "\\uD328\\uC2A4 127",
    d: "M30.766,81.648C20.125,81.648,0,79.964,0,73.6l.041-.33L18.282,0l2.654.66L2.753,73.693c.4,1.218,7.88,5.219,28.014,5.219s27.611-4,28.015-5.219L40.6.66,43.253,0,61.534,73.428V73.6c0,6.369-20.126,8.052-30.767,8.052",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1835",
    "data-name": "\\uC0AC\\uAC01\\uD615 1835",
    width: 100,
    height: 100,
    transform: "translate(-1112 -8483)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBusinessA);
export default __webpack_public_path__ + "static/media/main_business_a.6744300230e6d424aae876274f910f9e.svg";
export { ForwardRef as ReactComponent };